export default {
  inserted: function (el) {
    do {
      // We use slice on the font size to remove "px" units
      el.style.fontSize = (parseInt(getComputedStyle(el).fontSize.slice(0, -2)) - 1) + 'px'
    } while (el.scrollHeight > el.offsetHeight)
  }
}
